import { SVGProps } from 'react'

export const UserAddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg focusable="false" fill="currentColor" aria-hidden="true" viewBox="0 0 21.084 23.309" {...props}>
    <circle data-name="Ellipse 387" cx="5.481" cy="5.481" r="5.481" transform="translate(4.054)"></circle>
    <path
      data-name="Path 1350"
      d="M4.1 28.208h8.67c-2.554-2.38-3.905-6.628-2.077-9.784-1.813-.1-2.729-1.03-3.977-2.564A9.113 9.113 0 0 0 2 24.13v1.631a2.3 2.3 0 0 0 2.1 2.447z"
      transform="translate(-2 -4.899)"
    ></path>
    <path
      data-name="Path 1351"
      d="M16 22.709A5.709 5.709 0 1 0 21.709 17 5.709 5.709 0 0 0 16 22.709zm6.525-1.631v.816h.816a.816.816 0 0 1 0 1.631h-.816v.816a.816.816 0 1 1-1.631 0v-.816h-.816a.816.816 0 0 1 0-1.631h.816v-.816a.816.816 0 0 1 1.631 0z"
      transform="translate(-6.335 -6.039)"
    ></path>
  </svg>
)
